<template>
    <form-row title="Inspector">
        <div class="flex-1">
            <input-text
                class="-mt-4"
                name="inspection_company"
                :value="inspection.inspection_company"
                label="Company"
                placeholder="Company"
                :read_only="read_only"
            />

            <div class="mt-4">
                <contact-selector
                    name_prefix="inspector"
                    :available_contacts="available_contacts"
                    contact_type="inspector"
                    :value="{
                        contact_id: inspection.contact_id,
                        name: inspection.inspector_name,
                        email: inspection.inspector_email,
                        phone: inspection.inspector_phone,
                    }"
                    name_label="Inspector Name"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import ContactSelector from '../../components/contact-selector.vue';

export default {
    components: {
        ContactSelector,
    },

    props: {
        inspection: {},
        available_contacts: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
